module.exports = __webpack_public_path__ + "img/masthead5.2426322d.jpg";